import { call, put, all, takeEvery } from "redux-saga/effects";
import * as actions from "./actions";
import * as types from "../types";
import api from "../../../services/api";

function* getOrders({ payload }) {
  try {
    const response = yield call(api.get, `/ordersprofessional?page=0`);
    yield put(actions.getOrdersSuccess(response));
  } catch (e) {
    console.log(e);
  }
}

export default all([takeEvery(types.GET_ORDERS, getOrders)]);
